import React from 'react';
import { BoxFormTextField } from 'src/components/profileComponents/FormTextField';
import { translations } from 'src/constants/translations';
import { BoxFormAutocomplete } from 'src/components/profileComponents/FormAutocomplete';
import {
  IDevelopmentSpecificationPropChange,
} from 'src/components/profileComponents/Complexes/components/ProjectSpecification/types';
import {
  useStyles as mainUseStyles,
} from 'src/components/profileComponents/Marketplace/components/UnitsTiles/components/Common/styles';
import Box from '@mui/material/Box';
import {
  IMarketplacePlacementCardFirstHeaderMainElementBase,
} from 'src/typings/marketplaceTile';
import { IMarketplacePlacementProperty, Option } from 'src/components/profileComponents/Marketplace/types';
import { updateTranslatedField } from 'src/components/profileComponents/Marketplace/components/Filters/helpers';

interface Props<T> {
  entity: T,
  lang: string,
  propertyOptions: Option<IMarketplacePlacementProperty>[],
  onChange: (entity: T) => void,
}

export const UnitCardProperty = <T extends IMarketplacePlacementCardFirstHeaderMainElementBase>({
  entity, lang, propertyOptions, onChange,
}: Props<T>) => {
  const commonStyles = mainUseStyles();
  return (
    <Box display="flex" gap="20px" flex="auto">
      <div className={commonStyles.prefixSuffixWrapper}>
        <BoxFormTextField
          label={translations.prefix}
          name="prefix"
          defaultValue={entity.prefix?.[lang]}
          onChange={(e) => {
            onChange(updateTranslatedField(entity, 'prefix', lang, e.target.value));
          }}
        />
      </div>
      <div className={commonStyles.selectWrapper}>
        <BoxFormAutocomplete
          label={translations.propertyName}
          name="property"
          propertyToCompare="systemName"
          defaultValue={{ label: entity.property?.translates?.[lang] || entity.property?.systemName, value: entity.property }}
          onChange={(e: IDevelopmentSpecificationPropChange<IMarketplacePlacementProperty>) => {
            onChange({ ...entity, property: e.value });
          }}
          options={propertyOptions}
        />
      </div>
      <div className={commonStyles.prefixSuffixWrapper}>
        <BoxFormTextField
          label={translations.suffix}
          name="suffix"
          defaultValue={entity.suffix?.[lang]}
          onChange={(e) => {
            onChange(updateTranslatedField(entity, 'suffix', lang, e.target.value));
          }}
        />
      </div>
    </Box>
  );
};
